import React from 'react'
import DocumentsContainer from 'app/react/components/documents/DocumentsContainer'
import DocumentsContent from 'app/react/components/documents/DocumentsContent'

export default function DocumentsOverview (props) {
  return (
    <DocumentsContainer {...props}>
      <DocumentsContent />
    </DocumentsContainer>
  )
}